<template>
  <article class="user__profile_card">
    <h1 class="heading">
      {{ $t("alias.CREATE_ALIAS") }}
    </h1>
    <section id="create_alias">
      <aside id="user__profile_general">
        <p
          class="copy"
          v-html="$t('alias.ALIAS_INFO')"
        />
        <InfoBox :content="$t('alias.ALIAS_PERMANENT')" />
      </aside>
      <form>
        <div class="input">
          <label
            class="label__input required"
            for="alias-name"
          >{{
            $t("alias.ALIAS_NAME")
          }}</label>
          <input
            type="text"
            id="alias-name"
            name="alias-name"
            minlength="3"
            maxlength="50"
            v-model="aliasName"
            required
          >
        </div>
        <transition name="fade">
          <InfoBox
            v-if="showWarning"
            :content="$t('alias.ALIAS_RULES', { words: restrictedWords })"
            :is-warning="true"
          />
        </transition>
        <div class="input">
          <label
            class="label__input"
            for="alias-description"
          >{{ $t("user.PROFILE_DESCRIPTION") }}
            {{ currentCharacterCount }}</label>
          <textarea
            name="alias-description"
            id="alias-description"
            cols="30"
            rows="5"
            maxlength="500"
            v-model="aliasDescription"
          />
        </div>
        <section class="form__controls">
          <SpinnerButton
            :is-disabled="aliasIsInvalid"
            :button-id="'btn__save_alias'"
            :button-class="'btn__confirm'"
            :button-type="'submit'"
            :button-listener="onClickSubmitAlias"
            :button-text="$t('buttons.SAVE')"
          />
        </section>
      </form>
    </section>
  </article>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { VALID_CHARACTERS, RESTRICTED_WORDS } from "@/helpers/constants";
import InfoBox from "../global/InfoBox";
import SpinnerButton from "../global/SpinnerButton";

export default {
  name: "CreateAlias",
  components: {
    InfoBox,
    SpinnerButton,
  },
  data() {
    return {
      aliasName: "",
      aliasDescription: "",
      showWarning: false,
    };
  },
  computed: {
    ...mapGetters(["myProfile"]),
    currentCharacterCount() {
      return `(${this.aliasDescription.length}/500)`;
    },
    aliasIsInvalid() {
      if (this.aliasName.trim().length < 3) return true;
      if (!this.validateAlias(this.aliasName)) return true;
      return false;
    },
    restrictedWords() {
      const words = RESTRICTED_WORDS.toString().replace(/,/g, ", ");
      return words.replace(/("[^"]+"|\w+)$/, `${this.$t("general.OR")} $1`);
    },
  },
  methods: {
    ...mapActions(["createAlias"]),
    onClickSubmitAlias() {
      if (!this.validateAlias(this.aliasName)) return;

      this.createAlias({
        userId: this.myProfile.userId,
        name: this.aliasName.trim(),
        description: this.aliasDescription,
        profilePicture: process.env.VUE_APP_DEFAULT_PICTURE,
        imageRotation: 0,
      });
    },
    validateAlias(name) {
      const lowercase = name.toLowerCase();

      if (lowercase.trim().length < 3) return false;

      if (!VALID_CHARACTERS.test(lowercase)) {
        this.showWarning = true;
        return false;
      }

      if (RESTRICTED_WORDS.some((word) => lowercase.includes(word))) {
        this.showWarning = true;
        return false;
      }

      this.showWarning = false;
      return true;
    },
  },
};
</script>
